import { gql } from "@apollo/client";

const VALIDATE_RESET_TOKEN = gql`
  query validateResetToken($email: String, $token: String, $type: String) {
    validateResetToken(email: $email, token: $token, type: $type)
  }
`;

export default VALIDATE_RESET_TOKEN;
